/**
 * @generated SignedSource<<c37c8485f218e7a76d1bfb0857a2d20c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type ClassifyTxnsInputObject = {
  classification?: TxnClassificationEnum | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type useTxnBulkActions_ClassifyTxnsMutation$variables = {
  input: ClassifyTxnsInputObject;
};
export type useTxnBulkActions_ClassifyTxnsMutation$data = {
  readonly classifyTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type useTxnBulkActions_ClassifyTxnsMutation = {
  response: useTxnBulkActions_ClassifyTxnsMutation$data;
  variables: useTxnBulkActions_ClassifyTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTxnBulkActions_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTxnBulkActions_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "94de5563bc03fc0d244e428ac60c0120",
    "id": null,
    "metadata": {},
    "name": "useTxnBulkActions_ClassifyTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation useTxnBulkActions_ClassifyTxnsMutation(\n  $input: ClassifyTxnsInputObject!\n) {\n  classifyTxns(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87b63b17f94ba3bc908cf3940b72199e";

export default node;
